import { Button, Stack, Typography } from "@mui/material";

import { CustomerAddress } from "../../../models";
import { ButtonLoading, ModalContainer } from "../../../components/ui";

interface Props {
  open: boolean;
  candidates: CustomerAddress[];
  onClose: () => void;
  onCreateAnyway: () => void | Promise<void>;
  onSelectCustomer: (customerId: string) => void;
}

export const DuplicateCustomerPrompt = (props: Props) => {
  const { open, candidates, onClose, onCreateAnyway, onSelectCustomer } = props;

  return (
    <ModalContainer
      open={open}
      handleClose={onClose}
      title="Possible duplicate customers found"
    >
      <Stack spacing={2} sx={{ minWidth: 700 }}>
        <Typography variant="body1">
          We found customers that match the name and/or address entered. Are
          you sure you want to create a new customer?
        </Typography>
        <Stack spacing={1}>
          {candidates.map((candidate) => (
            <Stack
              key={`${candidate.customerId}-${candidate.addressId}`}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              sx={{ border: "1px solid", borderColor: "divider", p: 1.5 }}
            >
              <Stack>
                <Typography variant="subtitle1">{candidate.fullName}</Typography>
                <Typography variant="body2">{candidate.address}</Typography>
                {(candidate.phone || candidate.email) && (
                  <Typography variant="body2">
                    {[candidate.phone, candidate.email].filter(Boolean).join(" | ")}
                  </Typography>
                )}
              </Stack>
              <Button
                variant="outlined"
                onClick={() => {
                  onClose();
                  onSelectCustomer(candidate.customerId);
                }}
              >
                This is the customer I am looking for
              </Button>
            </Stack>
          ))}
        </Stack>
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <ButtonLoading variant="contained" onClick={onCreateAnyway}>
            Create anyway
          </ButtonLoading>
        </Stack>
      </Stack>
    </ModalContainer>
  );
};
